import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsoodehDashboardCalc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={194}
    height={188}
    fill='none'
    {...props}
  >
    <path fill='url(#asoodehDashboardCalc_svg__a)' fillOpacity={0.04} d='M0 .5h194v187H0z' />
    <defs>
      <pattern
        id='asoodehDashboardCalc_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#asoodehDashboardCalc_svg__b' transform='matrix(.00289 0 0 .003 -.002 0)' />
      </pattern>
      <image
        xlinkHref='/images/icons/asoodeh-dashboard-calc-237ea4a1.webp'
        id='asoodehDashboardCalc_svg__b'
        width={348}
        height={334}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgAsoodehDashboardCalc;
